// 路由管理 route.

export const RouterObj = {
  dashboard: {
    zh: '首页',
    en: 'dashboard',
    pu: 'Início'
  },
  agingHistoryRefresh: {
    zh: '时效历史数据更新',
    en: 'Aging History Refresh',
    pu: 'Atualização de histórico de SLA'
  },
  podInvalidKeywordConfig: {
    zh: 'POD审核失败分类配置',
    en: 'POD Audit Failure Category Config',
    pu: 'Configuração de classificação de falhas na auditoria de POD'
  },
  UserCenter: {
    zh: '用户中心',
    en: 'User center',
    pu: 'Centro de Usuários'
  },
  UserManagement: {
    zh: '用户管理',
    en: 'User management',
    pu: 'Gerenciamento de usuários'
  },
  RoleManagement: {
    zh: '角色管理',
    en: 'Role management',
    pu: 'Gestão de papéis'
  },
  PermissionManagement: {
    zh: '权限管理',
    en: 'Permission management',
    pu: 'Gerenciamento de permissões'
  },
  OrganizationalStructure: {
    zh: '组织架构',
    en: 'Organizational structure',
    pu: 'Estrutura organizacional'
  },
  JobManagement: {
    zh: '职务管理',
    en: 'Job management',
    pu: 'Gestão de empregos'
  },
  TicketCenter: {
    zh: '工单中心',
    en: 'Ticket center',
    pu: 'Centro de Ingressos'
  },
  MyMission: {
    zh: '我的任务',
    en: 'My mission',
    pu: 'Minha missão'
  },
  MyTicket: {
    zh: '我的工单',
    en: 'My ticket',
    pu: 'Meu bilhete'
  },
  DepartmentTickets: {
    zh: '部门工单',
    en: 'Department tickets',
    pu: 'Bilhetes do departamento'
  },
  DepartmentTasks: {
    zh: '部门任务',
    en: 'Department tasks',
    pu: 'Tarefas do departamento'
  },
  TicketLabel: {
    zh: '工单标签',
    en: 'Ticket label',
    pu: 'Etiqueta de ingressos'
  },
  DailyNewspaperManagement: {
    zh: '日报管理',
    en: 'Daily newspaper management',
    pu: 'Gestão diária de jornais'
  },
  MicroWorkOrder: {
    zh: '微工单',
    en: 'Micro work order',
    pu: 'tarefas internas'
  },
  OrderCenter: {
    zh: '快递订单',
    en: 'Order center',
    pu: 'Pedidos do expresso'
  },
  archivedOrderQuery: {
    zh: '归档订单查询',
    en: 'Archived Order Query',
    pu: 'Consulta de Pedidos Arquivados'
  },
  dictionary: {
    zh: '字典',
    en: '',
    pu: 'dicionário'
  },
  newDictType: {
    zh: '新字典',
    en: 'New Dictionary',
    pu: 'Novo Dicionário'
  },
  RemoteAreaPostcodeManagement: {
    zh: '偏远地区邮编管理',
    en: '',
    pu: 'Gerenciamento de CEP de Área Remota'
  },
  orderList: {
    zh: '订单列表',
    en: 'orderList',
    pu: 'Lista dos Pedidos'
  },
  OrderLogs: {
    zh: '快递下单日志',
    en: 'Order Log',
    pu: 'Registro de Pedidos Expressos'
  },
  customerOutboundLog: {
    zh: '客户出仓日志',
    en: 'Customer Outbound Log',
    pu: 'Registro de Saída de Clientes'
  },
  ReplaceOrder: {
    zh: '换单订单',
    en: 'Replacement order',
    pu: 'Ordem de troca'
  },
  // ServiceProviderChannel: {
  //   zh: '服务商渠道',
  //   en: 'Service provider channel',
  //   pu: 'Canal de prestadores de serviços'
  // },
  // SystemServiceProvider: {
  //   zh: '服务商渠道',
  //   en: 'Service provider channel',
  //   pu: 'Canal de prestadores de serviços'
  // },
  logisticsOrders: {
    zh: '物流订单',
    en: 'Logistics orders',
    pu: 'Pedidos de logística'
  },
  placeOrder: {
    zh: '快递下单',
    en: 'Place the order',
    pu: 'fazer pedido do express'
  },
  PendingReturnOrders: {
    zh: '待返仓订单',
    en: 'Pending return orders',
    pu: 'Pedido a aguardar devolver ao armazém'
  },
  ReturnWaybill: {
    zh: '退件运单',
    en: 'Return waybill',
    pu: 'Carta de porte de devolução'
  },
  OrderLog: {
    zh: '下单日志',
    en: 'Order Log',
    pu: 'Registro de pedidos'
  },
  LogisticsOrders: {
    zh: '物流订单',
    en: 'Logistics orders',
    pu: 'Ordens logísticas'
  },
  PlatformOrders: {
    zh: '平台订单',
    en: 'Platform orders',
    pu: 'Pedidos de plataforma'
  },
  ExchangeOrders: {
    zh: '换单订单',
    en: 'Exchange orders',
    pu: 'Ordens de troca'
  },
  OrderLargeScreen: {
    zh: '订单大屏展示',
    en: 'Order large screen',
    pu: 'Encomendar tela grande'
  },
  CourierSource: {
    zh: '快递来源',
    en: 'Courier source',
    pu: 'Fonte do correio'
  },
  ProblemPiece: {
    zh: '问题件记录',
    en: '',
    pu: 'Itens com problema'
  },
  collectOrder: {
    zh: '揽收订单报表',
    en: '',
    pu: 'Relatório de Pedidos de Coleta'
  },
  deliveryData: {
    zh: '揽收送仓数据监控',
    en: '',
    pu: 'Monitoramento de Dados de Coleta para o CD'
  },
  collectTimeReport: {
    zh: '揽收时效报表',
    en: '',
    pu: 'Relatório de SLA de Coleta'
  },
  collectNodeErrDataReport: {
    zh: '揽收节点异常数据监控报表',
    en: '',
    pu: 'Relatório de Monitoramento de Anomalias nos MDs'
  },
  KPIMonitoringReports: {
    zh: '揽收KPI监控报表',
    en: '',
    pu: 'Relatório de Monitoramento de KPIs de Coleta'
  },
  MonitoringReport: {
    zh: '订单揽收监控报表',
    en: '',
    pu: 'Relatório de Monitoramento de Pedidos de Coleta'
  },
  PushTrack: {
    zh: '轨迹推送',
    en: '',
    pu: 'Push de Rastreamento'
  },
  SMSManagement: {
    zh: '短信管理',
    en: '',
    pu: 'Gestão de SMS'
  },
  carMonitoring: {
    zh: '装车卸车数据监控',
    en: '',
    pu: 'Monitoramento de Dados de Carregamento e Descarregamento'
  },
  MerchantManagement: {
    zh: '商户管理',
    en: '',
    pu: 'Gestão de Lojistas'
  },
  TimeLimitForSigning: {
    zh: '签收时效报表统计',
    en: '',
    pu: 'Relatório Estatístico de SLA de Assinatura/Confirmação'
  },
  DotReceiveDailyReport: {
    zh: '网点揽收日报表',
    en: '',
    pu: 'Relatório Diário de Coleta por Filial/Ponto'
  },
  vehicleManagement: {
    zh: '车辆管理',
    en: '',
    pu: 'Gestão de veículos'
  },
  vehicleManagement1: {
    zh: '车辆维修',
    en: '',
    pu: 'Reparo de veículos'
  },
  carNumber: {
    zh: '车签号',
    en: '',
    pu: 'Número de escaneamento do veículo'
  },
  ListOfCountries: {
    zh: '国家列表',
    en: 'List of countries',
    pu: 'Lista de países'
  },
  ListOfProvinces: {
    zh: '省份列表',
    en: 'List of provinces',
    pu: 'Lista de províncias'
  },
  ListOfCities: {
    zh: '城市列表',
    en: 'List of cities',
    pu: 'Lista de cidades'
  },
  ListOfDowntownAreas: {
    zh: '市区列表',
    en: 'List of downtown areas',
    pu: 'Lista de áreas do centro'
  },
  DistrictManagement: {
    zh: '地区与税费',
    en: 'Regions & Taxes',
    pu: 'Regiões & Impostos'
  },
  IncomingSenderManagement: {
    zh: '收发件人管理',
    en: 'Incoming sender management',
    pu: 'Gerenciamento de remetente de entrada'
  },
  OrdersReport: {
    zh: '订单报表',
    en: 'Orders report',
    pu: 'Relatório de ordens'
  },
  OrderDataPush: {
    zh: '订单数据推送',
    en: 'Order data push',
    pu: 'Pressione os dados de ordem'
  },
  ChannelManagement: {
    zh: '渠道管理',
    en: 'Channel management',
    pu: 'Gestão de canais'
  },
  channel: {
    zh: '渠道',
    en: 'channel',
    pu: 'canal'
  },
  CustomerChannel: {
    zh: '客户渠道',
    en: 'customer channel',
    pu: 'canal do cliente'
  },
  SystemServiceProvider: {
    zh: '系统服务商',
    en: 'System service provider',
    pu: 'Provedor de serviços de sistema'
  },
  ServiceProviderChannels: {
    zh: '服务商渠道',
    en: 'Service provider channels',
    pu: 'Canais de provedor de serviços'
  },
  ServiceProviderChannelPublicField: {
    zh: '服务商渠道公共字段',
    en: 'Service provider channel publicField',
    pu: 'Provedor de serviços canaliza campo público'
  },
  ServiceProviderChannelRuleVerification: {
    zh: '服务商渠道规则校验',
    en: 'Service provider channel rule verification',
    pu: 'Verificação de regras de canal do provedor de serviços'
  },
  AlternateNumberPool: {
    zh: '备用号码池',
    en: 'Alternate number pool',
    pu: 'Pool de números alternativos'
  },
  NumberPool: {
    zh: '号码池',
    en: 'Number pool',
    pu: 'Pool de números'
  },
  FacetSingleTemplateManagement: {
    zh: '面单模板管理',
    en: 'Facet single template management',
    pu: 'Gerenciamento de modelo único faceta'
  },
  NextHomeList: {
    zh: '下家列表',
    en: 'Next home list',
    pu: 'Próxima lista de casas'
  },
  PlatformManagement: {
    zh: '平台管理',
    en: 'Platform management',
    pu: 'Gerenciamento de plataformas'
  },
  ServiceProviderErrorMessageComparison: {
    zh: '服务商错误信息对照',
    en: 'Service provider error message comparison',
    pu: 'Comparação de mensagens de erro do provedor de serviços'
  },
  OperationalLogs: {
    zh: '操作日志',
    en: 'Operational logs',
    pu: 'Diário de operações'
  },
  TrajectoryManagement: {
    zh: '轨迹管理',
    en: 'Tracking',
    pu: 'Rastreamento'
  },
  AListOfTracks: {
    zh: '轨迹列表',
    en: 'tracking list',
    pu: 'Lista de rastreamento'
  },
  TrackServiceProviderManagement: {
    zh: '轨迹服务商管理',
    en: 'Track service provider management',
    pu: 'Rastrear o gerenciamento do provedor de serviços'
  },
  TrajectoryStatus: {
    zh: '轨迹状态',
    en: 'Trajectory status',
    pu: 'Status da trajetória'
  },
  TrajectoryStateReference: {
    zh: '轨迹状态参照',
    en: 'Trajectory state reference',
    pu: 'Referência de estado de trajetória'
  },
  TrajectoryTemporaryMatching: {
    zh: '轨迹临时匹配',
    en: 'Trajectory temporary matching',
    pu: "Trajetória temporária pi'pei"
  },
  ChannelsAreInterconnectedWithOilCircuits: {
    zh: '渠道相关邮路',
    en: 'Channels are interconnected with oil circuits',
    pu: 'Os canais estão interligados com circuitos de petróleo'
  },
  TrajectoryQuery: {
    zh: '轨迹查询',
    en: 'Trajectory query',
    pu: 'Consulta de Rastreamento'
  },
  serviceTrajectoryMatching: {
    zh: '服务商轨迹匹配',
    en: '',
    pu: 'Correspondência de trilha de provedor de serviços'
  },
  trackStatus: {
    zh: '轨迹状态',
    em: 'Track status',
    pu: 'Status rastreamento'
  },
  TrackPushReport: {
    zh: '轨迹推送报表',
    en: 'Track push report',
    pu: 'Track push report'
  },
  TrajectoryStatisticsReport: {
    zh: '轨迹统计报表',
    en: 'Trajectory statistics report',
    pu: 'estatística de rastreamento'
  },
  AirlineBillLadingManagement: {
    zh: '航空提单管理',
    en: 'Airline bill of lading management',
    pu: 'Gestão de AWB'
  },
  TrajectoriesAreArtificiallyMade: {
    zh: '轨迹人工制作',
    en: 'Trajectories are artificially made',
    pu: 'rastreamento Manual'
  },
  RiskMonitoringCenter: {
    zh: '风控中心',
    en: 'Risk monitoring center',
    pu: 'Centro de Monitoramento de Riscos'
  },
  RiskMonitoringProducts: {
    zh: '风控产品',
    en: 'Risk monitoring products',
    pu: 'Produtos de monitoramento de riscos'
  },
  RiskMonitoringOrders: {
    zh: '风控订单',
    en: 'Risk monitoring orders',
    pu: 'Ordens de monitoramento de riscos'
  },
  largeJobManagement: {
    zh: '大件作业管理',
    en: '',
    pu: 'Gestão de Operações de Cargas Grandes'
  },
  collectingLoadingRecords: {
    zh: '揽收装车记录',
    en: '',
    pu: 'Registro de Carregamento de Coleta'
  },
  CustomerManagement: {
    zh: '客户管理',
    en: 'Customer management',
    pu: 'Customer management center'
  },
  CustomerList: {
    zh: '客户列表',
    en: 'Customer list',
    pu: 'Lista de clientes'
  },
  customerTimelinessManagement: {
    zh: '客户时效管理',
    en: '',
    pu: 'Gestão da prescrição de clientes'
  },
  expressTimelinessManagement: {
    zh: '快递时效管理',
    en: 'Express Timeliness Management',
    pu: 'Configuração de SLA'
  },
  CustomerKanban: {
    zh: '客户看板',
    en: 'Customer kanban',
    pu: 'Kanban cliente'
  },
  SortingCenter: {
    zh: '分拣中心',
    en: 'Sorting center',
    pu: 'Centro de triagem'
  },
  bulkyExpress: {
    zh: '大件快递',
    en: '',
    pu: 'Carga grande'
  },
  bulkyOrder: {
    zh: '大件订单',
    en: '',
    pu: 'Pedido de carga grande'
  },
  basicData: {
    zh: '基础数据',
    en: 'basic data',
    pu: 'Dados básicos'
  },
  SortingRules: {
    zh: '分拣规则',
    en: 'Sorting rules',
    pu: 'Regras de classificação'
  },
  NewSortingRules: {
    zh: '分拣规则',
    en: '',
    pu: 'Regras de triagem'
  },
  GridManagement: {
    zh: '格口管理',
    en: 'Grid management',
    pu: 'Gerenciamento de grade'
  },
  ZipCodeArea: {
    zh: '邮编分区',
    en: '',
    pu: 'Zipod'
  },
  sorterOrder: {
    zh: '分拣订单',
    en: '',
    pu: 'Ordenação de pedidos'
  },
  Lattice: {
    zh: '格口',
    en: 'Lattice',
    pu: 'Reticulado'
  },
  SorterLargeScreen: {
    zh: '分拣机大屏展示',
    en: 'Sorter large screen',
    pu: 'Tela grande sorter'
  },
  CourierCollection: {
    zh: '快递揽收',
    en: 'Courier collection',
    pu: 'Coleção de correios'
  },
  InboundOperations: {
    zh: '入库操作',
    en: 'Inbound operations',
    pu: 'Operações de entrada'
  },
  ListOfSmallPackets: {
    zh: '小包列表',
    en: 'List of small packets',
    pu: 'Lista de pacotes pequenos'
  },
  MessageCenter: {
    zh: '消息中心',
    en: 'Message center',
    pu: 'Centro de Mensagens'
  },
  ISentAMessage: {
    zh: '我发送的消息',
    en: 'ISent a message',
    pu: 'Eu enviei uma mensagem.'
  },
  IReceivedAMessage: {
    zh: '我接收的消息',
    en: 'I received a message',
    pu: 'Recebi uma mensagem.'
  },
  MessageTemplates: {
    zh: '消息模板',
    en: 'Message templates',
    pu: 'Modelos de mensagens'
  },
  SystemAdministration: {
    zh: '系统管理',
    en: 'System administration',
    pu: 'Administração do Sistema'
  },
  resourceManagement: {
    zh: '资源管理',
    en: 'resource management',
    pu: 'gestão dos recursos'
  },
  regionalAdministration: {
    zh: '大区管理',
    en: 'Regional administration',
    pu: 'Administração regional'
  },
  LoginLogs: {
    zh: '登录日志',
    en: 'Login logs',
    pu: 'Logs de login'
  },
  ContractManagement: {
    zh: '合同管理',
    en: 'Contract management',
    pu: 'Gestão de contratos'
  },
  MessageSystemParameters: {
    zh: '消息系统参数',
    en: 'Message system parameters',
    pu: 'Parâmetros do sistema de mensagens'
  },
  UserParameters: {
    zh: '用户参数',
    en: 'User parameters',
    pu: 'Parâmetros do usuário'
  },
  TheResourceExportList: {
    zh: '资源导出列表',
    en: 'The resource export list',
    pu: 'A lista de exportação de recursos'
  },
  TheResourceTaskList: {
    zh: '资源任务列表',
    en: 'Resource Task List',
    pu: 'Lista de tarefas de recursos'
  },
  TemplateVariableSettings: {
    zh: '模板变量设置',
    en: 'Template variable settings',
    pu: 'Configurações de variáveis de modelo'
  },
  ServiceHealthTesting: {
    zh: '服务健康检测',
    en: 'Service health testing',
    pu: 'Teste de saúde do serviço'
  },
  OrderTargetSettings: {
    zh: '订单目标设置',
    en: 'Order target settings',
    pu: 'Configurações de destino de ordem'
  },
  LargeScreenDisplay: {
    zh: '大屏展示',
    en: 'Large screen display',
    pu: 'Tela grande'
  },
  ButtonDoorTemporaryDataCache: {
    zh: '钮门临时数据缓存',
    en: 'Button door temporary data cache',
    pu: 'Cache de dados temporários da porta do botão'
  },
  collectionCenter: {
    zh: '揽收中心',
    en: 'Collect center',
    pu: 'Centro de Coleta'
  },
  customerHandDoor: {
    zh: '客户上门交件',
    en: '',
    pu: 'Consulta de Cliente Dropoff'
  },
  listingQuery: {
    zh: '揽收清单',
    en: '',
    pu: 'Lista de coleta'
  },
  lanshouOrder: {
    zh: '揽收订单',
    en: '',
    pu: 'Pedido de Coleta'
  },
  receivingCodeQuery: {
    zh: '揽收码查询',
    en: '',
    pu: 'Consulta de Código de Coleta'
  },
  // siteManagement: {
  //   zh: '站点管理',
  //   en: '',
  //   pu: 'Gerenciamento de ponto'
  // },
  siteManagement: {
    zh: '网点管理',
    en: '',
    pu: 'Gestão de Pontos'
  },
  postalCodeManagement: {
    zh: '快递邮编管理',
    en: 'Express delivery postal code management',
    pu: 'Gestão de CEPs de express'
  },
  sopPlatform: {
    zh: 'SOP中台',
    en: 'SOP Platform',
    pu: 'Plataforma SOP'
  },
  collectionTimeConfiguration: {
    zh: '揽收时效配置',
    en: '',
    pu: 'Configuração de SLA de Coleta'
  },
  driverManagement: {
    zh: '员工管理',
    en: '',
    pu: 'Gestão de funcionários'
  },
  stockUpReceiveOrders: {
    zh: '备货揽收订单',
    en: '',
    pu: 'Pedido de Coleta SFS'
  },
  noScheduledPickUpOrders: {
    zh: '无预报揽收订单',
    en: 'No scheduled pick-up orders',
    pu: 'Pedido de Coleta sem agendamento'
  },
  collectorInquire: {
    zh: '揽收商家查询',
    en: 'Receive business inquiries',
    pu: 'Consulta de Sellers'
  },
  orderLogQuery: {
    zh: '下单日志查询',
    en: '',
    pu: 'Consulta de Log de Pedidos'
  },
  receiveDataProcessing: {
    zh: '揽收数据处理',
    en: '',
    pu: 'Processamento de Dados de Coleta'
  },
  warehouseToWarehouse: {
    zh: '仓对仓揽收订单',
    en: '',
    pu: 'Pedido de Coleta entre CDs'
  },
  operatingPlatform: {
    zh: '操作平台',
    en: '',
    pu: 'Plataforma operacional'
  },
  dispatch: {
    zh: '派件',
    en: '',
    pu: 'Distribuição'
  },
  expressReturn: {
    zh: '快递退件',
    en: '',
    pu: 'Devoluções expressas'
  },
  signFor: {
    zh: '签收',
    en: '',
    pu: 'Assinatura'
  },
  collectWarehousing: {
    zh: '网点揽收入库',
    en: '',
    pu: 'Entrada do armazém na coleta no Ponto'
  },
  collectOutOfWarehouse: {
    zh: '网点揽收出库',
    en: '',
    pu: 'Fora do armazém na coleta no Ponto'
  },
  dispatchWarehousing: {
    zh: '网点派件入库',
    en: '',
    pu: 'Distribuição de entrada no Ponto'
  },
  signForQuery: {
    zh: '签收查询',
    en: '',
    pu: 'Consulta de Confirmações de Entrega'
  },
  FinancialCenter: {
    zh: '财务中心',
    en: 'Financial Center',
    pu: 'Centro Financeiro'
  },
  BasicInformation: {
    zh: '基础资料',
    en: 'Basic information',
    pu: 'Dados Básicos / Cadastro Básico'
  },
  PartitionManagement: {
    zh: '分区管理',
    en: 'Partition management',
    pu: 'Gerenciamento de partições'
  },
  AccountManagement: {
    zh: '账户管理',
    en: 'Account Management',
    pu: 'Gerenciamento de contas'
  },
  feesType: {
    zh: '费用类型',
    en: 'Fees type',
    pu: 'Tipo de custo'
  },
  quoteManagement: {
    zh: '报价管理',
    en: 'Quote management',
    pu: 'Gestão de cotações'
  },
  CustomerAccount: {
    zh: '客户账户',
    en: 'Customer Account',
    pu: 'Conta de Cliente'
  },
  BranchAccounts: {
    zh: '网点账户',
    en: 'Site account',
    pu: 'Conta do site'
  },
  DataPushLogs: {
    zh: '财务数据推送日志',
    en: 'Data push log',
    pu: 'Registro de Envio de Dados Financeiros'
  },
  PriceInquiryLog: {
    zh: '价格查询日志',
    en: 'DPrice inquiry log',
    pu: 'Consulta de preços log'
  },
  supplementCollectionLog: {
    zh: '补充揽收操作日志',
    en: 'Supplement Collection Operation Log',
    pu: 'Registro de Operação de Coleta Suplementar'
  },
  ReceivableManagementSite: {
    // zh: '应收管理（公司对网点）',
    // en: 'receivable management（Company to site）',
    // pu: 'gestão de recebíveis（Empresa para o site）'
    zh: '应收管理',
    en: 'receivable management',
    pu: 'gestão de recebíveis'
  },
  ReceivableManagementCompany: {
    zh: '应收管理（网点对客户）',
    en: 'receivable management（Site to customer）',
    pu: 'gestão de recebíveis（Site para o cliente）'
  },
  FeesApply: {
    zh: '应收费用',
    en: 'Fees apply',
    pu: 'Aplicam-se taxas'
  },
  BillingReview: {
    zh: '账单审核',
    en: 'Billing review',
    pu: 'Revisão de faturamento'
  },
  BillReconciliation: {
    zh: '账单核收',
    en: 'Bill reconciliation',
    pu: 'Reconciliação de contas'
  },
  WarehouseInbound: {
    zh: '仓库入库',
    en: 'Warehouse inbound',
    pu: 'Entrada no armazém'
  },
  ReceivingManagement: {
    zh: '收货管理',
    en: '',
    pu: 'coleta e gerenciamento'
  },
  WarehousingWeight: {
    zh: '入库称重',
    en: '',
    pu: 'armazenar e pesar'
  },
  WeighTheQuery: {
    zh: '称重查询',
    en: 'Weigh the query',
    pu: 'Pesquisar o peso'
  },
  WeighingRecords: {
    zh: '称重记录',
    en: 'Weighing records',
    pu: 'Registro de pesagem'
  },
  WeightCorrection: {
    zh: '重量校正',
    en: '',
    pu: 'correção do peso'
  },
  ScanBagging: {
    zh: '扫描装袋',
    en: 'Scan bagging',
    pu: 'Ensacamento de digitalização'
  },
  RemoveTheBag: {
    zh: '移除出袋',
    en: 'Remove the bag',
    pu: 'Retire o saco'
  },
  BigPackList: {
    zh: '大包列表',
    en: 'Big Pack list',
    pu: 'Lista de Big Pack'
  },
  WarehouseOutbound: {
    zh: '仓库出库',
    en: 'Warehouse outbound',
    pu: 'Saída de armazém'
  },
  bagworkList: {
    zh: '装袋记录',
    en: 'bagging list',
    pu: 'Registro de Ensacamento'
  },
  totalSingleList: {
    zh: '总单列表',
    en: '',
    pu: 'Lista Geral'
  },
  TotalSingleStowage: {
    zh: '总单配载',
    en: 'Total single stowage',
    pu: 'Saida do armazém'
  },
  operationCZ: {
    zh: '操作',
    en: 'operation',
    pu: 'Operação'
  },
  receiveSign: {
    zh: '揽收签收',
    en: '',
    pu: 'Confirmação de Recebimento da Coleta'
  },
  loadingConfirm: {
    zh: '装车确认',
    en: '',
    pu: 'Confirmação de Carregamento'
  },
  transferCenterVehicleConfirm: {
    zh: '转运中心车辆确认',
    en: '',
    pu: 'Confirmação de Veículo de Transferência'
  },
  receiveInfoVerifyQuery: {
    zh: '揽收信息确认查询',
    en: '',
    pu: 'Consulta de Confirmação de Informações de Coleta'
  },
  transferCenterVehicleConfirmQuery: {
    zh: '转运中心车辆确认查询',
    en: '',
    pu: 'Consulta de Confirmação de Veículo de Transferência'
  },
  receiveScan: {
    zh: '非预报揽收',
    en: '',
    pu: 'Coleta sem Pré-Aviso'
  },
  loadingScan: {
    zh: '装车扫描',
    en: '',
    pu: 'Escaneamento de Carregamento'
  },
  unloadingScan: {
    zh: '卸车扫描',
    en: '',
    pu: 'Escaneamento de Descarregamento'
  },
  packetScan: {
    zh: '稽包扫描',
    en: '',
    pu: 'Escaneamento de Auditoria de Saca'
  },
  bagNumQuery: {
    zh: '袋号查询',
    en: '',
    pu: 'Consulta de Nº de Saca'
  },
  problem: {
    zh: '问题件',
    en: 'Problem piece',
    pu: 'Registrar anomalia'
  },
  packetQuery: {
    zh: '稽包查询',
    en: '',
    pu: 'Consulta de pacote inspecionado'
  },
  monitorStatisticsStatement: {
    zh: '监控/统计报表',
    en: '',
    pu: 'Relatórios de Monitoramento/Estatísticas'
  },
  basicDate: {
    zh: '基础资料',
    en: '',
    pu: 'Dados Básicos / Cadastro Básico'
  },
  finance: {
    zh: '财务',
    en: '',
    pu: 'Financeiro'
  },
  bill: {
    zh: '账单推送',
    en: '',
    pu: 'Envio de Cobranças'
  },
  quotationMaintenance: {
    zh: '报价维护',
    en: '',
    pu: 'Manutenção de Cotação'
  },
  mailingArea: {
    zh: '寄件区域',
    en: '',
    pu: 'Área de Postagem/Envio'
  },
  zipZone: {
    zh: '邮编分区',
    en: '',
    pu: 'Divisão Zip Code'
  },
  zipZoneManagement: {
    zh: '邮编管理',
    en: '',
    pu: 'Gestão de CEPs'
  },
  trackQuery: {
    zh: '轨迹查询',
    en: '',
    pu: 'Consulta de Rastreamento'
  },
  CollectKanban: {
    zh: '揽收看板',
    en: '',
    pu: 'Painel de Coleta'
  },
  daily: {
    zh: '揽收日报',
    en: '',
    pu: 'Relatório Diário de Coleta'
  },
  collectOperationalData: {
    zh: '揽收运营数据',
    en: '',
    pu: 'Dados Operacionais de Coleta'
  },
  collectionOperationDashboard: {
    zh: '揽收运营数据看板',
    en: 'Collection Operations Dashboard',
    pu: 'Painel de Operação de Coleta'
  },
  mdHoldupTable: {
    zh: 'md滞留表',
    en: '',
    pu: 'Tabela de Backlog MD'
  },
  supplier: {
    zh: '供应商列表',
    en: 'List of vendors',
    pu: 'Lista de fornecedores'
  },
  PrintedSheet: {
    zh: '打印面单',
    en: '',
    pu: 'Imprimir etiquetas'
  },
  singleScan: {
    zh: 'SingleScan',
    en: 'Single Scan',
    pu: 'Scan Único'
  },
  singleScanZH: {
    zh: '单次扫描',
    en: 'Single Scan',
    pu: 'Scan Único'
  },
  replaceBag: {
    zh: 'Replace Bag',
    en: 'Replace Bag',
    pu: 'Troca de Saca'
  },
  Transport: {
    zh: '运输管理中心',
    en: 'Transport',
    pu: 'Transporte'
  },
  delivery: {
    zh: 'Delivery',
    en: 'Delivery',
    pu: 'Entregador'
  },
  vehicle: {
    zh: '车辆',
    en: 'Vehicle',
    pu: 'Veículos'
  },
  route: {
    zh: '路线',
    en: 'Route',
    pu: 'Rota'
  },
  driver: {
    zh: '司机',
    en: 'Driver',
    pu: 'Motorista'
  },
  equipment: {
    zh: 'Equipment',
    en: 'Equipment',
    pu: 'Equipamento'
  },
  seller: {
    zh: '卖方',
    en: 'Seller',
    pu: 'Seller'
  },
  trailer: {
    zh: '拖车',
    en: 'trailer',
    pu: 'Carreta'
  },
  transfer: {
    zh: '转账',
    en: 'transfer',
    pu: 'Transferencia'
  },
  bank: {
    zh: '银行',
    en: 'bank',
    pu: 'Banco'
  },
  base: {
    zh: '基地',
    en: 'Base',
    pu: 'Base'
  },
  company: {
    zh: '公司',
    en: 'company',
    pu: 'Companhia'
  },
  transferRoutes: {
    zh: '转运路线',
    en: 'Transfer Routes',
    pu: 'Rotas de transferência'
  },
  edition: {
    zh: '版本',
    en: 'Edition',
    pu: 'Edição'
  },
  reverse: {
    zh: '反向 Panini',
    en: 'Reverse Panini',
    pu: 'Reverso Panini'
  },
  orderTransport: {
    zh: 'Order transport',
    en: 'Order transport',
    pu: 'Ordem de transporte'
  },
  editionUpload: {
    zh: '版本上传',
    en: 'Edition upload',
    pu: 'Upload de edição'
  },
  controlTower: {
    zh: '控制塔',
    en: 'Control Tower',
    pu: 'Torre de Controle'
  },
  FunctionalStatistics: {
    zh: '功能统计',
    en: '',
    pu: 'Estatísticas de funções'
  },
  ReportManagement: {
    zh: '数据报表',
    en: '',
    pu: 'Folha de dados'
  },
  orderPush: {
    zh: '订单推送',
    en: '',
    pu: 'push do pedido'
  },
  cancelOrder: {
    zh: '订单取消',
    en: 'Order Cancellation',
    pu: 'Cancelamento do Pedido'
  },
  tablePrice: {
    zh: 'Price table',
    en: 'Price table',
    pu: 'Tabela de Preços'
  },
  TransporteStatus: {
    zh: '干线状态',
    en: '',
    pu: 'Transporte de linha principal'
  },
  smartCabinet: {
    zh: '智能柜',
    en: '',
    pu: 'gabinete inteligente'
  },
  cabinetInformation: {
    zh: '柜子信息',
    en: '',
    pu: 'Informações do gabinete'
  },
  latticeMaintenance: {
    zh: '格子维护',
    en: '',
    pu: 'Manutenção da treliça'
  },
  cabinetMaintenance: {
    zh: '柜子维护',
    en: '',
    pu: 'Manutenção do gabinete'
  },
  ShippingInvoices: {
    zh: '运输发票',
    en: 'Shipping invoices',
    pu: 'Faturas de envio'
  },
  invoice: {
    zh: '发票',
    en: 'invoice',
    pu: 'fatura'
  },
  UnloadingPoint: {
    zh: '卸货点',
    en: '',
    pu: 'Ponto de descarga'
  },
  entregaMDFE: {
    zh: '派送MDFE',
    en: '',
    pu: 'entrega MDFE'
  },
  ShiftManagement: {
    zh: '班次管理',
    en: '',
    pu: 'Gestão de turnos'
  },
  DryBranchFlowManagement: {
    zh: '干支线流向管理',
    en: '',
    pu: 'Gestão de Fluxo de Linhas de Transporte Primário e Secundário'
  },
  CurrencyManagement: {
    zh: '币种管理',
    en: 'Currency Management',
    pu: 'Gerenciamento de moedas'
  },
  InsurancePushTable: {
    zh: '保险推送表',
    en: 'Insurance Push Form',
    pu: 'Formulário de envio de seguro'
  },
  SupplierManagement: {
    zh: '服务商系统管理',
    en: 'SupplierManagement',
    pu: 'Gestão de fornecedores'
  },
  VendorRole: {
    zh: 'SRM系统角色',
    en: 'Vendor role',
    pu: 'Função do Sistema SRM'
  },
  VendorPermissions: {
    zh: 'SRM系统权限',
    en: 'Supplier permissions',
    pu: 'Permissões do sistema SRM'
  },
  VendorAccountNumber: {
    zh: '供应商账号',
    en: 'Supplier account',
    pu: 'Lista de mensagens'
  },
  OperatorsManual: {
    zh: 'SRM操作手册',
    en: "Operator's manual",
    pu: 'Manual da SRM'
  },
  MessageList: {
    zh: '留言列表',
    en: 'Message List',
    pu: 'Lista de mensagens'
  },
  AccountOpening: {
    zh: '账号开通',
    en: 'Account opening',
    pu: 'Abertura de conta'
  },
  ParcelReturned: {
    zh: '待退回包裹',
    en: '',
    pu: 'Pacotes a serem devolvidos'
  },
  TrackReceptionManagement: {
    zh: '轨迹接收管理',
    en: 'Track Reception Management',
    pu: 'Gerenciamento de Recebimento de Rastreamento'
  },
  TrajectoryStatusMonitoring: {
    zh: '轨迹与状态同步监控',
    en: '',
    pu: 'Monitoramento de sincronização de rastreamento e status'
  },
  SMSConfiguration: {
    zh: '短信配置',
    en: 'SMS configuration',
    pu: 'Mensagem de configuração'
  },
  operationGuide: {
    zh: '操作指南',
    en: '',
    pu: 'Guia de operação'
  },
  TrackPushManagement: {
    zh: '轨迹推送管理',
    en: 'Track Push Management',
    pu: 'Gerenciamento de Envio de Rastreamento'
  },
  ManualSortingRoute: {
    zh: '手动分拣',
    en: '',
    pu: 'Classificação manual'
  },
  ReverseOrders: {
    zh: '逆向订单',
    en: 'Reverse orders',
    pu: 'Pedido reverso'
  },
  MinutaList: {
    zh: 'Minuta列表',
    en: '',
    pu: 'Lista Minuta'
  },
  WaybillTimeliness: {
    zh: '运单时效监控',
    en: '',
    pu: 'Monitoramento da pontualidade de pedido'
  },
  SupplierData: {
    zh: '供应商数据',
    en: 'Supplier Data',
    pu: 'Dados de Fornecedor'
  },
  dotScanRate: {
    zh: '网点扫描率',
    en: '',
    pu: 'Taxa de bipe de ponto'
  },
  kanbanBoard: {
    zh: '运单看板',
    en: '',
    pu: 'Dashboard de pedido'
  },
  receivable: {
    zh: '应收',
    en: 'receivable',
    pu: 'receber'
  },
  payable: {
    zh: '应付',
    en: 'payable',
    pu: 'Pagável'
  },
  payableTransportation: {
    zh: '应付-运输',
    en: 'Payable - Transportation',
    pu: 'Pagável - Transporte'
  },
  AccountsPayable: {
    zh: '应付账户',
    en: 'Accounts payable',
    pu: 'Conta a Pagar'
  },
  allLinkTimeStatistics: {
    zh: '全链路时效统计',
    en: '',
    pu: 'Estatísticas de tempo de toda a cadeia'
  },
  PayableManagement: {
    zh: '应付管理',
    en: 'Payable management',
    pu: 'Gestão a Pagar'
  },
  FeesPayable: {
    zh: '应付费用',
    en: 'Fees payable',
    pu: 'Taxas a pagar'
  },
  DispatchReferenceTable: {
    zh: '派送参照表',
    en: 'Dispatch reference table',
    pu: 'Tabela de referência de expedição'
  },
  HutDispatchAccountsPayable: {
    zh: '安骏小屋应付账户',
    en: '',
    pu: 'Mini Drop Contas a pagar'
  },
  DispatchAccountsPayable: {
    zh: 'AJD派送应付账户',
    en: 'AJD Dispatch accounts payable',
    pu: 'AJD Despachar contas a pagar'
  },
  DspDispatchAccountsPayable: {
    zh: 'DSP派送应付账户',
    en: '',
    pu: 'DSP Despachar contas a pagar'
  },
  AccountsReceivablePayable: {
    zh: '揽收应付账户',
    en: 'Accounts receivable and payable',
    pu: 'Contas a receber e a pagar'
  },
  order: {
    zh: '订单',
    en: 'order',
    pu: 'Pedido'
  },
  returnCenter: {
    zh: '退件中心',
    en: '',
    pu: 'Centro de Devoluções'
  },
  returnQuery: {
    zh: '退件查询',
    en: '',
    pu: 'Consulta sobre devoluções'
  },
  BillVerification: {
    zh: '账单核付',
    en: 'Bill verification',
    pu: 'Verificação de Faturas'
  },
  RouteDistanceReference: {
    zh: '路线距离参照表',
    en: 'route distance reference table',
    pu: 'Mesa de referência da distância da rota'
  },
  FranchiseeTimelinessStatistics: {
    zh: '网点时效统计',
    en: '',
    pu: 'Estatísticas de Prazo dos Parceiros'
  },
  ExpressDeliveryMonitoring: {
    zh: '快递时效监控',
    en: '',
    pu: 'Monitoramento de prazo de entrega'
  },
  DeviceManagement: {
    zh: '设备管理',
    en: 'Device management',
    pu: 'Gestão de equipamento'
  },
  vehicleUsageStatistics: {
    zh: '车辆使用统计',
    en: 'Vehicle Usage Statistics',
    pu: 'Estatística de Utilização de Veículos'
  },
  InvoiceManagement: {
    zh: '发票管理',
    en: 'Invoice management',
    pu: 'Gestão de faturas'
  },
  FileUploadManagement: {
    zh: '文件上传管理',
    en: 'File Upload Management',
    pu: 'Gerenciamento de upload de arquivos'
  },
  DataDheet: {
    zh: '数据报表',
    en: 'data sheet',
    pu: 'folha de dados'
  },
  CollectionDailyReceivableStatistics: {
    zh: '揽收每日应收统计报表',
    en: 'Collection of daily statistical statements of receivables',
    pu: 'Cobrança de extratos estatísticos diários de contas a receber'
  },
  sysInfo: {
    zh: '系统消息',
    en: '',
    pu: 'Informação de sistema'
  },
  largeParcelCollection: {
    zh: '大包裹揽收',
    en: '',
    pu: 'Coleta de Pacotes Grandes'
  },
  ReadyReceiveScanning: {
    zh: '备货揽收扫描',
    en: '',
    pu: 'Bipar Coleta SFS'
  },
  bagScanning: {
    zh: '封袋',
    en: 'Close bag',
    pu: 'Fechar Saca'
  },
  outGoRecord: {
    zh: '快递扫描记录',
    en: '',
    pu: 'Registro de Digitalização Expressa'
  },
  PackagePrinting1: {
    zh: '包牌打印',
    en: '',
    pu: 'Imprimir código de barra de Nº de saca'
  },
  arrive: {
    zh: '到件',
    en: '',
    pu: 'Entrada'
  },
  sender: {
    zh: '发件',
    en: '',
    pu: 'Saída'
  },
  arrivalRecord: {
    zh: '到件记录',
    en: '',
    pu: 'Registro de chegada de pacotes'
  },
  newReplaceBag: {
    zh: '袋子替换',
    en: '',
    pu: 'Substituição de Saca'
  },
  personnelRegistration: {
    zh: '人员登记',
    en: '',
    pu: 'Registro de pessoal'
  },

  ClaimsManagement: {
    zh: '理赔管理',
    en: '',
    pu: 'Gestão de reclamações'
  },
  ClaimList: {
    zh: '理赔列表',
    en: '',
    pu: 'Lista de reclamações'
  },
  ClaimStatement: {
    zh: '理赔账单',
    en: '',
    pu: 'Cobrança de sinistros'
  },
  ClaimsReviewRules: {
    zh: '理赔审核规则',
    en: '',
    pu: 'Regras de revisão de sinistros'
  },
  signMultipleOrders: {
    zh: '多次签收订单',
    en: '',
    pu: 'Assinação o pedido várias vezes'
  },
  misallocationRateName: {
    zh: '分拨错发率',
    en: '',
    pu: 'Taxa de erro de distribuição'
  },
  quickOrderChange: {
    zh: '快速换单',
    en: '',
    pu: 'Troca rápida de pedidos'
  },
  LoadingDocument: {
    zh: '装车文件',
    en: '',
    pu: 'Documentos de carregamento'
  },
  requestMessageList: {
    zh: '网点留言列表',
    en: '',
    pu: 'Lista de mensagens do ponto'
  },
  lossRateMonitoring: {
    zh: '遗失率监控',
    en: '',
    pu: 'Monitorização da taxa de perdas'
  },
  TransferKanbanBoard: {
    zh: '转运看板',
    en: '',
    pu: 'Painel de Transferência'
  },
  DeliveryLoading: {
    zh: '派送装车监控',
    en: '',
    pu: 'Monitoramento de Carregamento de Entrega'
  },
  expressLoadingMonitor: {
    zh: '快递装车监控',
    en: '',
    pu: 'Monitoramento de Carregamento de Expresso'
  },
  loadingUnloadingDataMonitoring: {
    zh: '装卸车数据监控',
    en: 'Loading/Unloading Data Monitoring',
    pu: 'Monitoramento de Dados de Carregamento/Descarga'
  },
  trackStopMonitoring: {
    zh: '轨迹停更监控',
    en: '',
    pu: 'Monitoramento de Atualização de Rastreamento'
  },
  returnDataMonitoring: {
    zh: '退件数据监控',
    en: '',
    pu: 'Monitoramento de Dados de Devolução'
  },
  endCollectionMonitoring: {
    zh: '末端揽收监控',
    en: '',
    pu: 'Monitoramento de coleta LM'
  },
  allocateDetentionMonitoring: {
    zh: '分拨滞留监控',
    en: '',
    pu: 'Monitoramento de Retenção na Distribuição'
  },
  ReturnOperationRecord: {
    zh: '退件操作记录',
    en: '',
    pu: 'Registro de Operação de Devolução'
  },
  PostalCodeCorrection: {
    zh: '邮编纠正',
    en: '',
    pu: 'Correção de CEP'
  },
  CompensationManagement: {
    zh: '索赔管理',
    en: '',
    pu: 'Gestão de Pedidos de Indenização'
  },
  CompensationList: {
    zh: '索赔列表',
    en: '',
    pu: 'Lista de Pedidos de Indenização'
  },
  CompensationStatement: {
    zh: '索赔账单',
    en: '',
    pu: 'Fatura do Pedido de Indenização'
  },
  CompensationRuleList: {
    zh: '索赔规则列表',
    en: '',
    pu: 'Lista de regras de reivindicação'
  },
  agingManagement: {
    zh: '时效管理',
    en: '',
    pu: 'Gestão de Eficácia'
  },
  staticAgingMonitoring: {
    zh: '静态时效监控',
    en: '',
    pu: 'Monitoramento de Eficácia Estática'
  },
  serviceOroviderOrder: {
    zh: '服务商订单',
    en: '',
    pu: 'Pedido do parceiro'
  },
  customerIssuemanagement: {
    zh: '本地客户问题件管理',
    en: '',
    pu: 'Gerenciamento de pacotes de problemas do cliente local'
  },
  ComprehensiveCost: {
    zh: '应付综合费用',
    en: '',
    pu: 'Custo global'
  },
  ThirdPartyCollection: {
    zh: '第三方揽收',
    en: '',
    pu: 'Coleta por treceiro'
  },
  AnjunCottage: {
    zh: '安骏小屋',
    en: '',
    pu: 'Minidrop'
  },
  AJDDispatch: {
    zh: 'AJD派送',
    en: '',
    pu: 'Entrega por AJD'
  },
  DSPDispatch: {
    zh: 'DSP派送',
    en: '',
    pu: 'Entrega por DSP'
  },
  postOfficeDelivery: {
    zh: '邮局派送',
    en: '',
    pu: 'Entrega dos Correios'
  },
  MDDDispatch: {
    zh: 'MDD派送',
    en: '',
    pu: 'Entrega por MDD'
  },
  addressBaseManagement: {
    zh: '地址库管理',
    en: '',
    pu: 'Gerenciamento da biblioteca de endereços'
  },
  replaceScanner: {
    zh: '换单扫描',
    en: '',
    pu: 'Troca de verificação de ordem'
  },
  TransportationTrunkFeeder: {
    zh: '运输（干/支线）',
    en: 'Transportation (Trunk/Feeder)',
    pu: 'Transporte (seco/ramo)'
  },
  signLatLonMonitoring: {
    zh: '签收经纬度监控',
    en: '',
    pu: 'Monitoramento da latitude e longitude da assinatura'
  },
  SignLimitConfiguration: {
    zh: '签收限制配置',
    en: '',
    pu: 'Configuração de Restrição de Assinatura'
  },
  largeOrderManagement: {
    zh: '大件订单管理',
    en: '',
    pu: 'Gestão de Pedidos de Cargas Grandes'
  },
  wovenBagManagement: {
    zh: '编织袋管理',
    en: '',
    pu: 'Gestão de Sacas'
  },
  detailManagement: {
    zh: '回收明细',
    en: '',
    pu: 'Detalhes da reciclagem'
  },
  recyclingSummaryQuery: {
    zh: '回收汇总查询',
    en: '',
    pu: 'Consulta de resumo de reciclagem'
  },
  MonthlySummary: {
    zh: '按月汇总',
    en: '',
    pu: 'Resumo por mês'
  },
  ComplaintWorkOrder: {
    zh: '投诉工单',
    en: 'Complaint Work Order',
    pu: 'Reclamação e Acareação'
  },
  usageConfiguration: {
    zh: '使用量配置',
    en: '',
    pu: 'Configuração de uso'
  },
  recyclingManagement: {
    zh: '回收管理',
    en: '',
    pu: 'Reciclagem'
  },
  expressSignage: {
    zh: '快递看板',
    en: '',
    pu: 'Express dashboard'
  },
  sortingManagement: {
    zh: '分拣管理',
    en: '',
    pu: 'Gerenciamento de classificação'
  },
  expressDataCenter: {
    zh: '快递中心',
    en: '',
    pu: 'Centro do expresso'
  },
  serviceQuality: {
    zh: '服务质量管理',
    en: '',
    pu: 'QOS'
  },
  ITResourceManagement: {
    zh: 'IT资源管理',
    en: '',
    pu: 'Gestão de recursos de TI'
  },
  orderSearch: {
    zh: '订单查询',
    en: '',
    pu: 'Consulta de pedidos'
  },
  MenuSerch: {
    zh: '菜单搜索',
    en: '',
    pu: 'Pesquisa de Menu'
  },
  changePwd: {
    zh: '修改密码',
    en: 'changePwd',
    pu: 'Alterar a senha'
  },
  personalCenter: {
    zh: '个人中心',
    en: 'Personal Center',
    pu: 'Centro Pessoal'
  },
  MDFE: {
    zh: 'MDFE',
    en: 'MDFE',
    pu: 'MDFE'
  },
  MandatorySignatureVerification: {
    zh: '强制签收审核',
    en: '',
    pu: 'Auditoria de Pacotes'
  },
  qualityService: {
    zh: '服务质量',
    en: '',
    pu: 'QOS'
  },
  SortingMachineSignboard: {
    zh: '分拣机看板',
    en: 'Sorting machine signboard',
    pu: 'Taxa de ordenamento de máquinas'
  },
  DailyReportSingleVolumeBusinessModules: {
    zh: '单量看板',
    en: 'Daily report of single volume for business modules',
    pu: 'Painel de Volume de Pedidos'
  },
  CostsPayableAccount: {
    zh: '成本应付账户',
    en: 'Costs payable account',
    pu: 'Conta de custos a pagar'
  },
  costManagement: {
    zh: '成本管理',
    en: 'cost management',
    pu: 'gerenciamento de custos'
  },
  costsFee: {
    zh: '成本费用',
    en: 'costs Fee',
    pu: 'Custo'
  },
  costAudit: {
    zh: '成本审核',
    en: 'costAudit',
    pu: 'Auditoria de custos'
  },
  costApproval: {
    zh: '成本核付',
    en: 'cost Approval',
    pu: 'Aprovação de custos'
  },
  completeLink: {
    zh: '全环节看板',
    en: '',
    pu: 'Painel de Monitoramento Completo'
  },
  expressOperationKanbanBoard: {
    zh: '快递运营看板',
    en: '',
    pu: 'Painel de Operações'
  },
  getSortCode: {
    zh: '获取分拣码',
    en: 'Get Sorting Code',
    pu: 'obter o IATA'
  },
  problemConfig: {
    zh: '问题件配置',
    en: '',
    pu: 'Configuração do pedido problemático'
  },
  retainedPackageScan: {
    zh: '留仓件扫描',
    en: '',
    pu: 'Escaneamento de Pacote Retido'
  },
  falseDeliveryDailyReport: {
    zh: '虚假签收日报',
    en: 'False Delivery Daily Report',
    pu: 'Relatório Diário de Entregas Falsas'
  },
  lossRateStats: {
    zh: '丢损率统计',
    en: 'Loss Rate Stats',
    pu: 'Estat. % Perdas'
  },
  sortingMissedScanMonitor: {
    zh: '分拣漏扫监控',
    en: '',
    pu: 'Monitoramento de leitura faltante na triagem'
  },
  returnNote: {
    zh: '退件单',
    en: '',
    pu: 'Nota de Devolução'
  },
  ReturnNoteRecord: {
    zh: '退件单下单记录',
    en: 'Return order order record',
    pu: 'Registros de colocação de pedidos de devolução'
  },
  bulletinBoard: {
    zh: '看板',
    en: 'bulletin board',
    pu: 'quadro de avisos'
  },
  AccountsReceivableDashboard: {
    zh: '应收看板',
    en: 'Accounts receivable dashboard',
    pu: 'Painel de contas a receber'
  },
  OperationRecord: {
    zh: '操作记录',
    en: 'Operation record',
    pu: 'Registro de Operações'
  },
  regionConfig: {
    zh: '大区配置',
    en: 'Region Configuration',
    pu: 'Configuração de Região'
  },
  LargeOrderManagement1: {
    zh: '大件下单管理',
    en: 'Large order management',
    pu: 'Gerenciamento de pedidos de cargas grandes'
  },
  ProtocolRecord: {
    zh: '协议记录',
    en: 'Protocol Record',
    pu: 'Registro do protocolo'
  },
  onDutyRegistration: {
    zh: '上岗人数登记',
    en: 'On-Duty Personnel Registration',
    pu: 'Registro de Pessoal em Serviço'
  },
  deliveryDriverInvitationCode: {
    zh: '派送司机邀请码',
    en: 'Delivery Driver Invitation Code',
    pu: 'Código de Convite para Motorista de Entrega'
  },
  largeItemWeightRecord: {
    zh: '大件称重记录',
    en: 'Large item weight record',
    pu: 'Registro de peso de itens grandes'
  },
  EndKanbanBoard: {
    zh: '末端揽收看板',
    en: 'Last Mile Collection Dashboard',
    pu: 'Painel de Coleta de Última Milha'
  },
  dashboardPlatform: {
    zh: '看板平台',
    en: 'Dashboard Platform',
    pu: 'Plataforma de Painéis'
  },
  pickupServiceDashboard: {
    zh: '揽收业务看板',
    en: 'Pickup Service Dashboard',
    pu: 'Painel de Serviço de Coleta'
  },
  DefiniteResponsibilityAndPenalty: {
    zh: '定责与扣罚',
    en: 'Definite Responsibility and Penalty',
    pu: 'Responsabilidade e multa'
  },
  fixDuty: {
    zh: '定责',
    en: 'fix duty',
    pu: 'Responsabilidade'
  },
  LMLiabilityForLosses: {
    zh: 'LM损失定责',
    en: 'LM Liability for Losses',
    pu: 'Perdas LM'
  },
  FMLossDetermination: {
    zh: 'FM损失定责',
    en: 'FM Liability for Losses',
    pu: 'Perdas FM'
  },
  deliveryHubDashboard: {
    zh: '派送网点看板',
    en: 'Delivery Hub Dashboard',
    pu: 'Painel do Centro de Distribuição'
  },
  transportDashboard: {
    zh: '运输看板',
    en: 'Transport Dashboard',
    pu: 'Painel de Transporte'
  },
  sortingDashboard: {
    zh: '分拣看板',
    en: 'Sorting Dashboard',
    pu: 'Painel de Triagem'
  },
  internalLeadTime: {
    zh: '内部时效',
    en: 'Internal Lead Time',
    pu: 'Prazo Interno'
  },
  ManagementMailingRules: {
    zh: '应发件规则管理',
    en: 'Should-Be-Received-Item Rule Management',
    pu: 'Gerenciamento de Regras de Itens a Serem Recebidos'
  },
  ShouldSendDataMonitoring: {
    zh: '应发件数据监控',
    en: 'Should send data monitoring',
    pu: 'Monitoramento de dados de envio'
  },
  deliveryMonitor: {
    zh: '包裹尝试投递监控',
    en: 'Package delivery attempt monitoring',
    pu: 'Monitoramento de Reentregas'
  },
  returnCodePrint: {
    zh: '退件码打印',
    en: 'Return Code Printing',
    pu: 'Impressão de Código de Devolução'
  },
  oversizedDashboard: {
    zh: '大件看板',
    en: 'Oversized Dashboard',
    pu: 'Painel de Cargas Grandes'
  },
  oversizeOrderDashboard: {
    zh: '大件订单看板',
    en: 'Oversize Order Dashboard',
    pu: 'Painel de Pedidos de Cargas Grandes'
  },
  invoiceCenter: {
    zh: '发票中心',
    en: 'Invoice Center',
    pu: 'Centro de Faturas'
  },
  mdfeOperationLog: {
    zh: 'MDFE操作日志',
    en: 'MDFE Operation Log',
    pu: 'Registro de Operações MDFE'
  },
  abnormalReport: {
    zh: '异常上报',
    en: 'Abnormality Report',
    pu: 'Relatório de Anormalidade'
  },
  handoverException: {
    zh: '交接异常工单',
    en: 'Handover Exception',
    pu: 'Exceção de Transferência'
  },
  SortingMachineScanRecord: {
    zh: '分拣机扫描记录',
    en: 'Sorting Machine Scan Record',
    pu: 'Registro de digitalização do classificador'
  },
  ReceivableAccount: {
    zh: '应收账户',
    en: 'Receivable Account',
    pu: 'Conta a Receber'
  },
  BankPaymentManagement: {
    zh: '银行付款管理',
    en: 'Bank Payment Management',
    pu: 'Gestão de Pagamentos Bancários'
  },
  ReportDashboard: {
    zh: '报表看板',
    en: 'Report Dashboard',
    pu: 'Painel de Relatórios'
  },
  report: {
    zh: '报表',
    en: 'Report',
    pu: 'Relatório'
  },
  dailyCollectionReceivableReport: {
    zh: '揽收每日应收统计报表',
    en: 'Daily Collection Receivable Statistics Report',
    pu: 'Relatório Estatístico Diário de Recebíveis de Coleta'
  },
  bulkOrderAgreement: {
    zh: '大件下单协议',
    en: 'Bulk Order Agreement',
    pu: 'Acordo de Pedido em Volume'
  },
  timingMonitoring: {
    zh: '时效监控类',
    en: 'Timing Monitoring',
    pu: 'Categoria de pontualidade'
  },
  operationMonitoring: {
    zh: '操作监控类',
    en: 'Operation Monitoring',
    pu: 'Categoria de operação'
  },
  bulkCollectionRecord: {
    zh: '大件揽收记录',
    en: 'Bulk Collection Record',
    pu: 'Registro de coleta de grandes pacotes'
  },
  exceptionMonitoring: {
    zh: '异常监控类',
    en: 'Exception Monitoring',
    pu: 'Ategoria de anomalia'
  },
  sortingDataRecord: {
    zh: '分拣数据记录',
    en: 'Sorting Data Record',
    pu: 'Registro de triagem'
  },
  sortingConfiguration: {
    zh: '分拣配置管理',
    en: 'Sorting Configuration Management',
    pu: 'Configuração de triagem'
  },
  afterSalesCenter: {
    zh: '售后管理中心',
    en: 'After-sales Service Center',
    pu: 'Centro de Pós-venda'
  },
  lossResponsibility: {
    zh: '损失定责',
    en: 'Loss Responsibility Determination',
    pu: 'Determinação de Responsabilidade por Perdas'
  },
  claimsManagement: {
    zh: '理赔管理',
    en: 'Claims Management',
    pu: 'Gestão de Reclamações'
  },
  exceptionManagement: {
    zh: '异常管理中心',
    en: 'Exception Management Center',
    pu: 'Centro de Exceções'
  },
  trackingManagement: {
    zh: '轨迹管理中心',
    en: 'Tracking Management Center',
    pu: 'Centro de Rastreamento'
  },
  technicalSupport: {
    zh: '技术支持中心',
    en: 'Technical Support Center',
    pu: 'Centro de TI'
  },
  configurationManagement: {
    zh: '配置管理',
    en: 'Configuration Management',
    pu: 'Gestão de Configuração'
  },
  logManagement: {
    zh: '日志管理',
    en: 'Log Management',
    pu: 'Gestão de Logs'
  },
  helpCenter: {
    zh: '帮助中心',
    en: 'Help Center',
    pu: 'Central de Ajuda'
  },
  messageCenter: {
    zh: '消息中心',
    en: 'Message Center',
    pu: 'Centro de Mensagens'
  },
  mdfeAlert: {
    zh: 'MDFE拦截提醒',
    en: 'MDFE Alert',
    pu: 'Alerta MDFE'
  },
  stateDailyOperationReport: {
    zh: '各州每日操作日报',
    en: 'Daily State Operations Report',
    pu: 'Relatório Diário de Operações por Estado'
  },
  ReceivablesStatistics: {
    zh: '应收看板',
    en: 'Receivables Statistics',
    pu: 'Estatísticas de Contas a Receber'
  },
  DailyCollectionReceivableReportIndex: {
    zh: '总览明细',
    en: 'Overview Details',
    pu: 'Detalhes do Panorama'
  },
  ReceivedReceivablesReport: {
    zh: '快递已签收报表汇总',
    en: '',
    pu: 'Resumo do Relatório de Entrega Expressa Assinada'
  },
  AccountsReceivableTrend: {
    zh: '应收趋势',
    en: 'Accounts Receivable Trend',
    pu: 'Tendência de Contas a Receber'
  },
  dailyCollectionReceivableReportBusiness: {
    zh: '业务总览明细',
    en: 'Business Overview Details',
    pu: 'Detalhes do Panorama de Negócios'
  },
  dailyCollectionReceivableReportCustomer: {
    zh: '客户总览明细',
    en: 'Customer Overview Details',
    pu: 'Detalhes do Panorama de Clientes'
  },
  SortingOperation: {
    zh: '分拣操作',
    en: 'Sorting Operation',
    pu: 'Operação de triagem'
  },
  ExpressOrderDataPushQuery: {
    zh: '快递订单数据推送查询',
    en: 'Express Order Data Push Query',
    pu: 'Consulta de Push de Dados de Pedidos de Correios'
  },
  CTE: {
    zh: 'CTE',
    en: 'CTE',
    pu: 'CTE'
  },
  CustomerQualityDashboard: {
    zh: '客户质量看板',
    en: 'Customer Quality Dashboard',
    pu: 'Painel de Qualidade do Cliente'
  },
  hubInventoryBoard: {
    zh: 'HUB库存监控看板',
    en: 'HUB Inventory Board',
    pu: 'Painel de Estoque HUB'
  },
  ontimeDeliveryDashboard: {
    zh: '准时签收率看板',
    en: 'On-time delivery rate dashboard',
    pu: 'Painel de taxa de entrega no prazo'
  },
  trackingPushDashboard: {
    zh: '轨迹推送看板',
    en: 'Tracking Push Dashboard',
    pu: 'Painel de Envio de Rastreamento'
  },
  PreLoadTruckPickup: {
    zh: '预装车集货',
    en: 'Pre-load Truck Pickup',
    pu: 'Pré-consolidação'
  },
  duplicateOrderNumberInquiry: {
    zh: '重复订单号查询',
    en: 'Duplicate Order Number Inquiry',
    pu: 'Consulta de Número de Pedido Duplicado'
  },
  NfseDataCheck: {
    zh: 'Nfse数据核对',
    en: 'Nfse Data Check',
    pu: 'Verificação de Dados Nfse'
  },
  customerClosureTimeEfficiency: {
    zh: '客户闭环时效',
    en: 'Customer Closed-loop Time Efficiency',
    pu: 'Eficiência do tempo de ciclo fechado do cliente'
  },
  billingCalendarTrendChart: {
    zh: 'CTE开票日历趋势图',
    en: 'CTE Invoice Calendar Trend Chart',
    pu: 'Gráfico de tendência de calendário de faturamento CTE'
  },
  missedOperationDashboard: {
    zh: '漏操作看板',
    en: 'Missed Operation Dashboard',
    pu: 'Painel de Operações Omitidas'
  },
  onTimeDeliveryMonitoring: {
    zh: '准时派送监控',
    en: 'On-time Delivery Monitoring',
    pu: 'Monitoramento de Entrega a Tempo'
  },
  packageConsolidationRecords: {
    zh: '集包操作记录',
    en: 'Package Consolidation Records',
    pu: 'Registros de Consolidação de Pacotes'
  },
  MDFEExcludeRepeatedLoadingData: {
    zh: 'MDFE剔除装车重复数据',
    en: 'MDFE Exclude Repeated Loading Data',
    pu: 'Excluir dados de carga repetidos de MDFE'
  },
  expressTrackingList: {
    zh: '快递轨迹清单',
    en: 'Express Tracking List',
    pu: 'Lista de Rastreamento Expresso'
  },
  CustomerInvoiceSubjectConfiguration: {
    zh: '客户开票主体配置',
    en: 'Customer Invoice Subject Configuration',
    pu: 'Configuração de Assunto de Faturamento do Cliente'
  },
  invoiceInformationOperationLog: {
    zh: '开票信息操作日志',
    en: 'Invoice Information Operation Log',
    pu: 'Log de Operação de Informações de Faturamento'
  },
  HolidayConfiguration: {
    zh: '节假日配置',
    en: 'Holiday Configuration',
    pu: 'Configuração de Feriados'
  },
  returnCodeActivation: {
    zh: '退件码开通',
    en: 'Return Code Activation',
    pu: 'Ativação do Código de Devolução'
  },
  misroutingConfig: {
    zh: '错发路径配置',
    en: 'Misrouting Configuration',
    pu: 'Configuração de Rotas Permitidas'
  },
  CrossBorderCustomerIncomeDetailStatement: {
    zh: '跨境客户收入明细表',
    en: 'Cross-border Customer Income Detail Statement',
    pu: 'Demonstrativo Detalhado de Renda de Clientes Transfronteiriços'
  },
  trackingUpdateManagement: {
    zh: '轨迹停更管理',
    en: 'Tracking Update Management',
    pu: 'Gestão de interrupção de rastreio'
  },
  PODCheck: {
    zh: 'POD有效性验证',
    en: 'Return Code Activation',
    pu: 'Validação de validade do POD'
  },
  ReceivedReportDetails: {
    zh: '快递已签收报表明细',
    en: '',
    pu: 'Detalhes do Relatório de Entrega de Encomendas Assinadas'
  },
  insuranceServiceConfiguration: {
    zh: '保险服务配置',
    en: 'Insurance Service Configuration',
    pu: 'Configuração de Serviços de Seguro'
  },
  sortingTimelyRateStatistics: {
    zh: '分拣及时率统计',
    en: 'Sorting Timely Rate Statistics',
    pu: 'Estatísticas da Taxa de Triagem Puntual'
  },
  BusinessDashboard: {
    zh: '经营看板',
    en: 'Business Dashboard',
    pu: 'Painel de Negócios'
  },
  SummaryOfPickedUpAndSignedReports: {
    zh: '已揽收报表汇总',
    en: 'Collected Report Summary',
    pu: 'Resumo do relatório de coletados'
  },
  ReceivableSettlementDashboard: {
    zh: '应收结算看板',
    en: 'Receivable Settlement Dashboard',
    pu: 'Painel de Liquidação a Receber'
  },
  CollectionSignedReportDetails: {
    zh: '已揽收报表明细',
    en: 'Collected Report Detail',
    pu: 'Detalhe do relatório de coletados'
  },
  OperationLimitConfiguration: {
    zh: '操作限制配置',
    en: 'Operation Limit Configuration',
    pu: 'Configuração de Limites de Operação'
  },
  OperationLimitRelease: {
    zh: '操作限制解除',
    en: 'Operation Limit Release',
    pu: 'Liberação de Limites de Operação'
  },
  NewCustomerInvoiceSubjectConfiguration: {
    zh: '新客户开票主体配置',
    en: 'New Customer Invoice Subject Configuration',
    pu: 'Configuração de Assunto de Faturamento de Novo Cliente'
  },
  sorting: {
    zh: '分拣机管理',
    en: 'Sorter Management',
    pu: 'Gerenciamento de Classificador'
  },
  ChuteView: {
    zh: '格口视图',
    en: 'Chute View',
    pu: 'Visão de Calha'
  },
  RuleGroupList: {
    zh: '规则组管理',
    en: 'Rule Group',
    pu: 'Grupo de Regras'
  },
  RuleList: {
    zh: '分拣规则',
    en: 'Sorting Rules',
    pu: 'Regras de Triagem'
  },
  SortingRecord: {
    zh: '分拣记录',
    en: 'Sorting Records',
    pu: 'Registros de Triagem'
  },
  WeighingRecord: {
    zh: 'DWS称重记录',
    en: 'DWS Weighing Records',
    pu: 'Registros de Pesagem DWS'
  },
  UploadRecord: {
    zh: '落袋记录',
    en: 'Bagging Record',
    pu: 'Registro de Encaixotamento'
  },
  SortingMetricReport: {
    zh: '分拣数量统计',
    en: 'Sorting Metric Report',
    pu: 'Relatorio de Quantidade de Triagem'
  },
  TrackingOverdueStatistics: {
    zh: '轨迹超期统计',
    en: 'Tracking Overdue Statistics',
    pu: 'Estatísticas de Tempo de Rastreio Excedente'
  },
  wrongDelivery: {
    zh: '错发监控',
    en: 'Wrong Delivery Monitor',
    pu: 'Monitoramento de Envio Errado'
  },
  fileExportManagement: {
    zh: '文件导出管理',
    en: 'File Export Management',
    pu: 'Gerenciamento de Exportação de Arquivos'
  },
  Feishu: {
    zh: '飞书',
    en: 'Feishu',
    pu: 'Feishu'
  },
  penaltyConfirmationDocument: {
    zh: 'LM扣罚对账单',
    en: 'LM Penalty Statement',
    pu: 'Extrato de Multas LM'
  },
  ContractLedger: {
    zh: '合同台账',
    en: 'Contract Ledger',
    pu: 'Livro de Registros de Contratos'
  },
  PaymentDetails: {
    zh: '付款明细',
    en: 'Payment Details',
    pu: 'Detalhes do Pagamento'
  },
  ReceivableBill: {
    zh: '应收账单',
    en: 'Receivable Bill',
    pu: 'Conta a Receber'
  },
  customerPushOrderLog: {
    zh: '客户推单日志',
    en: 'Customer Push Order Log',
    pu: 'Log de Envio de Pedido do Cliente'
  },
  replacementConsolidation: {
    zh: '换单揽收集包',
    en: 'Waybill Replacement Collection Consolidation',
    pu: 'Consolidação de Coleta com Troca de Romaneio'
  },
  CTEArchivedDataQuery: {
    zh: 'CTE归档数据查询',
    en: 'CTE archived data query',
    pu: 'Consulta de dados arquivados CTE'
  },
  CTEInvoiceCalendarArchivedTrendChart: {
    zh: 'CTE开票日历归档趋势图',
    en: 'CTE Invoice Calendar Archived Trend Chart',
    pu: 'Gráfico de Tendência de Arquivamento de Calendário de Faturamento CTE'
  },
  CompensationDashboard: {
    zh: '赔付看板',
    en: 'Compensation Dashboard',
    pu: 'Painel de Indemnização'
  },
  bulkPendingPickupDashboard: {
    zh: '大件待揽收看板',
    en: 'Bulk Pending Pickup Dashboard',
    pu: 'Painel de Pendentes de Coleta de Cargas Grandes'
  },
  cteInvoicingExceptionStatistics: {
    zh: 'CTE开票异常统计',
    en: 'CTE Invoicing Exception Statistics',
    pu: 'Estatísticas de Exceções de Faturamento CTE'
  },
  smsSendLog: {
    zh: '短信发送日志',
    en: 'SMS Send Log',
    pu: 'Log de Envio de SMS'
  },
  warehouseOperationStatistics: {
    zh: '仓内作业统计',
    en: 'Warehouse Operation Statistics',
    pu: 'Estatísticas de Operações no Armazém'
  },
  FundManagement: {
    zh: '资金管理',
    en: 'Fund Management',
    pu: 'Gestão de Fundos'
  },
  FundLedger: {
    zh: '资金台账',
    en: 'Fund Ledger',
    pu: 'Livro de Registros de Fundos'
  },
  CustomerRechargeDetails: {
    zh: '客户充值明细表',
    en: 'Customer Recharge Details',
    pu: 'Detalhes de Recarga do Cliente'
  },
  FundTransactionDetails: {
    zh: '资金发生明细表',
    en: 'Fund Transaction Details',
    pu: 'Detalhes de Transações de Fundos'
  },
  ChannelVolume: {
    zh: '渠道材积',
    en: 'Channel Volume',
    pu: 'Volume de Canal'
  },
  sorterVolumeStatistics: {
    zh: '分拣机货量统计',
    en: 'Sorter Volume Statistics',
    pu: 'Estatísticas de Volume do Classificador'
  },
  CustomerFundTimeSeries: {
    zh: '客户资金时序表',
    en: 'Customer Fund Time Series',
    pu: 'Tabela de Séries Temporais de Fundos do Cliente'
  },
  slaTimelinessDashboard: {
    zh: 'SLA时效看板',
    en: 'SLA Timeliness Dashboard',
    pu: 'Painel de Prazo SLA'
  },
  AirwayPushConfiguration: {
    zh: '航空推送配置',
    en: 'Airway Push Configuration',
    pu: 'Configuração de Push de Aéreo'
  },
  AirwayPushRecord: {
    zh: '航空推送记录',
    en: 'Airway Push Record',
    pu: 'Registro de Push de Aéreo'
  },
  TemporaryWorkerAccountManagement: {
    zh: '临时工账号管理',
    en: 'Temporary worker account management',
    pu: 'Gestão de Contas de Freelancers'
  },
  CTEOperationLog: {
    zh: 'CTE操作日志',
    en: 'CTE Operation Log',
    pu: 'Registro de operações CTE'
  },
  StatusMonitoringAndWarning: {
    zh: '开票主体状态监控与告警',
    en: 'Monitoring of Issuer Status and Alerts',
    pu: 'Monitoramento de Status de Entidades Emissoras e Alertas'
  }
};
